module.exports = __webpack_public_path__ + "static/img/iconhome.5524cfc6.svg";